<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="产品">
              <el-select
                v-model="searchParams.proId"
                clearable
                @change="chgPro"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in productList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Sprint">
              <el-select
                v-model="searchParams.sprintId"
                @change="chgSprint"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in this.sprintListData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-show="selectTeam">
            <el-form-item label="团队">
              <template>
                <el-tag>{{ selectTeam }}</el-tag>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <el-button type="primary" icon="el-icon-plus" @click="toSave()" size="mini"  v-has-permission-code-and="'0040000000050000'" 
        >添加审视计划</el-button
      >
      <el-button
      v-has-permission-code-and="'0040000000050005'" 
        type="danger"  size="mini"
        icon="el-icon-delete"
        @click="batchRemove()"
        >批量删除</el-button
      >
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData.records"
        stripe
        border
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >

        <el-table-column
          prop="modeName"
          label="计划名称"
        ></el-table-column>
        <el-table-column
          prop="dbColumn_crer"
          label="创建人"
        ></el-table-column>

        
        <el-table-column
          prop="meetingName"
          label="会议名称"
         
        ></el-table-column>
        <!-- <el-table-column prop="springblogId" label="sprint待办列表"></el-table-column> -->
        <el-table-column
          prop="teamName"
          label="团队"
          width="160"
        ></el-table-column>

        <el-table-column prop="state"  width="100px" label="审视状态">
          <template slot-scope="props">
            {{
              props.row.state == 1
                ? "未开始"
                : props.row.state == 2
                ? "进行中"
                : props.row.state == 3
                ? "未完成"
                : props.row.state == 4
                ? "已完成"
                : props.row.state == 5
                ? "已关闭"
                : props.row.state == 6
                ? "已挂起"
                : "已延期"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="bugcnt"  width="100" label="bug数量"></el-table-column>
        <el-table-column
          prop="pbgntm"
          width="180"
          label="计划开始时间"
        ></el-table-column>
        <el-table-column
          prop="bgntm"
          width="180"
          label="实际开始时间"
        ></el-table-column>

        <el-table-column label="操作" fixed="right" width="300px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button size="mini" @click="toDetail(scope.$index, scope.row)"
                >详情</el-button
              >
              <el-button size="mini" @click="toSurvey(scope.row)"
                >审视记录</el-button
              >
              <el-button size="mini" @click="toUpdate(scope.$index, scope.row)"   v-has-permission-code-and="'0040000000050000'" 
                >编辑</el-button
              >
              <el-button   v-has-permission-code-and="'0040000000050000'" 
                size="mini"
                type="danger"
                @click="remove(scope.$index, scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-drawer
        title="审视"
        size="60%"
        :visible.sync="drawer"
        :before-close="handleClose"
      >
        <el-form label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="实际开始" prop="bgntm">
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择审视实际开始时间"
                  v-model="surveyRecord.bgntm"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="实际完成" prop="endtm">
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择审视实际完成时间"
                  v-model="surveyRecord.endtm"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="bug数量" prop="bugcnt">
                <el-input
                  placeholder="审视出的bug数量"
                  v-model="surveyRecord.bugcnt"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="审视结论" prop="examine">
                <wang-edit  :isupdt="isUpdtWedit" v-model="surveyRecord.examine"></wang-edit>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button
          type="primary"
          :loading="confirmLoading"
          @click="saveSurveyRecord()"
          >确 定</el-button
        >
        <el-button @click="drawer = false">取 消</el-button>
      </el-drawer>
      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="page.size"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>
      </div>
    </div>
    <edit ref="edit"></edit>
    <listRecord ref="listRecord"></listRecord>
  </div>
</template>
<script>
import edit from "./edit.vue";
import api from "@/api/sprint/survey/survey.js";
import apiProductBoard from "@/api/product/productBoard/productBoard.js";
import wangEdit from "@/components/wangEdit/wangEdit.vue";
import apiSBL from "@/api/sprint/sprintBacklog/sprintBacklog.js";

import productApi from "@/api/product/product/product.js";
 
import apiTeamMember from "@/api/team/teamMember/teamMember.js";
import listRecord from "@/views/sprint/survey_record/listRecord.vue";

export default {
  name: "survey",
  components: {
    edit,
    wangEdit,
    listRecord,
  },
  data() {
    return {
      searchParams: {},
      surveyRecord: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      popupLoading: false,
      confirmLoading: false,
      drawer: false,
      page: new this.$constant.pageObj(),
      sprintId: "",
      sprintListData: [], //获取到产品的sprint
      selectProd: "", //选中的产品id
      productList: [], //装载产品的数据
      teamAndMember: [], //查询出来的团队和成员
      selectTeam: "", //选中的团队
      pids: [], //父pid列表
      me: {},
      isUpdtWedit: false, //用于更新wangEdit
    };
  },
  methods: {
    isShow(row) {
      //管理员可以
      if ('ad' == this.me.role) {
        return true
      } else if (row.state == 1) {   //未开始的 
        if (this.me.id == row.crer) {   //创建人可以删
          return true
        }
      }
      return false
    },
    //页面初始化,获取产品数据，从浏览器获取存储的产品和sprint数据， 主要是初始化顶部搜索框条件
    init() {

      this.productList = this.$caches.products.get();
      const proId = this.$caches.pid.get();
      const sprid = this.$caches.sprintId.get();   

			if (!this.productList) {
				//获取产品数据并存入productData
				productApi.list4Select({}, response => {
					this.productList = response.data;
          //this.searchParams.proId = this.productList[0].name;
					this.$caches.products.set(this.productList);
				})
			}

  
      //初始化搜索框内容
      if (!this.selectProd) {
        //如果没有选中过产品就到浏览器查看是否存有选过的产品数据，没有就不进行操作（第一次打开页面）
        //const proId = localStorage.getItem("pid");
    
        if (proId) {
          //浏览器存有id则设置产品的id
          this.searchParams.proId = proId;
         
          //查询该产品的sprint数据并存入	sprintListData
          apiSBL.getSBLByProId(
              this.searchParams ,
            (response) => {
              this.sprintListData = response.data;

              //查看浏览器是否存有sprintid
              if (sprid) {
                //如果有产品id则设置选择框的sprint
                // TODO 是否要校验这个从浏览器获取的sprintID是不是 属于浏览器存的产品的sprint
                this.sprintId = sprid;
                this.searchParams.sprintId = sprid;
                this.getTeamMember();
 
              } else {
                //console.log("初始化没有sprintID!!!!!!!");
                //如果浏览器没有sprintID则默认选中产品的第一个sprint  并存入浏览器
                this.sprintId = this.sprintListData[0].id;
                this.searchParams.sprintId = this.sprintListData[0].id;
                //this.$caches.sprintId.set(this.sprintListData[0].id)
                localStorage.setItem("sprintId", this.sprintListData[0].id);
                this.getTeamMember();
              }
              this.list();
            }
          );
        } else {
          //第一次操作默认没有pid，也就是默认产品和sprint没有默认选择显示。
          //浏览器没有产品id则不进行操作
          let params = [];
          let pid = "";
          //请求获取pid列表
          apiProductBoard.productList(params, (response) => {
            params = response.data;
            for (let idx = 0; idx < params.length; idx++) {
              this.pids.push({
                value: params[idx].id,
                label: params[idx].name,
              });
            }

            //默认第一个
            if (this.pids[0]) {
              pid = this.pids[0].value;
            }

            this.$caches.pid.set(pid);
            this.init();
          });
        }
      }
    },
    //获取数据
    list() {
      let params = this.$utils.merger(this.searchParams, this.page);
      this.selectTeam = "";
      api.list(params, (response) => {
        this.listData = response.data;
        if (this.listData.records && this.listData.records.length > 0) {
          this.selectTeam = this.listData.records[0].teamName;
        }
        this.listLoading = false;
      });
    },
 
    //去添加
    toSave() {
      console.log(this.teamAndMember);
      this.$refs.edit.open({ sprId: this.sprintId , teamMembers: this.teamAndMember}, "添加-审视计划");
      
    },
    //去编辑
    toUpdate(index, row) {
      let editParameter = {
        id: row.id,
      };
      this.$refs.edit.open(editParameter, "编辑-审视计划");
    },
    //去详情
    toDetail(index, row) {
      let detailParameter = {
        id: row.id,
      };
      this.$refs.edit.open(detailParameter, "审视计划详情", true);
    },
    //查看审视记录
    toSurvey(row) {
 
      let detailParameter = row;
      this.$refs.listRecord.open(detailParameter, "查询审视记录", "80%");
      /* this.drawer = true,
			this.surveyRecord.id=row.id; */
    },
    handleClose(done) {
      done();
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let parameter = {
        ids: this.selected,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          {
            ids: this.selected,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },
    //产品改变
    chgPro(val) {
      this.$caches.pid.set(val);
      let proId = val;
      this.selectProd = val;
      this.searchParams.proId = val;
      apiSBL.getSBLByProId({ proId }, (response) => {
        this.sprintListData = response.data;
        if (response.data.length !== 0) {
          this.searchParams.sprintId = this.sprintListData[0].id;
          this.sprintId = this.sprintListData[0].id;
          localStorage.setItem("sprintId", this.sprintListData[0].id);
          this.getTeamMember();
          this.list();
        } else {
          this.list();
          localStorage.removeItem("sprintId");
          this.searchParams.sprintId = "";
          this.sprintId = "";
        }
      });
    },
    //sprint改变
    chgSprint(val) {
      this.sprintId = val;
      this.searchParams.sprintId = val;
      localStorage.setItem("sprintId", val);
      this.teamAndMember = [];
      this.getTeamMember();
      // this.getTeamMsgBySprId();
      this.list();
    },
    //获取团队成员
    getTeamMember() {
      // if (!this.teamAndMember || this.teamAndMember.length==0) {
      apiTeamMember.getTMemberBySprId(false, (response) => {
        if (response.data) {
          this.teamAndMember = response.data;
          this.$caches.teammembes.set(this.teamAndMember);
        }
      });
      // }
    },
    //审视记录保存
    saveSurveyRecord() {
     // console.log("survey", this.surveyRecord);
      let params = this.$utils.merger(this.surveyRecord);
      api.update(
        params,
        (response) => {
          this.$utils.msg.success("审视记录保存成功");
        },
        (err) => {
          this.$utils.msg.success("审视记录保存失败");
        }
      );
      this.drawer = false;
      this.list();
    },

    //搜索
    search() {
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
    },
  },
  mounted() {
    this.me = this.$caches.user.get();
    this.init();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>

